import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";

import { generateAutomationName } from "../../../../helpers/generateAutomationName";

type DomainListSectionHeaderProps = {
    currentSize: number;
    dataAutomationNames: string[];
    limit: number;
    subtitle: string;
    title: string;
    tooltipText: string;
};

export const DomainListSectionHeader = ({
    currentSize,
    dataAutomationNames,
    limit,
    subtitle,
    title,
    tooltipText,
}: DomainListSectionHeaderProps) => (
    <Stack gap="12px">
        <Flex
            alignItems="center"
            gap="8px"
        >
            <Text
                color={colorsPalettes.carbon[400]}
                data-automation={generateAutomationName("settings", [...dataAutomationNames, "title"])}
                fontVariant="subtitle1"
            >
                {title}
            </Text>
            <InfoTooltip infoText={tooltipText} />
        </Flex>
        <Flex
            alignItems="center"
            justifyContent="space-between"
        >
            <Text
                color={colorsPalettes.carbon[500]}
                fontVariant="body2"
            >
                {subtitle}
            </Text>
            <Text
                color={colorsPalettes.carbon[200]}
                data-automation={generateAutomationName("settings", [...dataAutomationNames, "limitation", "wrapper"])}
                fontVariant="subtitle1"
            >
                {currentSize}/{limit}
            </Text>
        </Flex>
    </Stack>
);
